import DollarTagIcon from '../../../../../icons/dollar-tag.svg?react';
import UserIcon from '../../../../../icons/user.svg?react';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg?react';
import DocumentIcon from '../../../../../icons/document.svg?react';

export default function PurchasingProcessData() {
    return {
        subtitle: "Using Covr's quoter gives you the best supplemental insurance options from across the market.",
        image: "/product-landing/term/circle1.png",
        steps: [
            {
                title: "Get a Quote",
                icon: DollarTagIcon,
                paragraphs: [
                    "We tried to make this easy. Use the quoter above to enter your information and get supplemental insurance quote based on individual plans.",
                ]
            },
            {
                title: "Select and Apply",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "Select the supplemental insurance policy you would like included in your plan. After you have entered from contact information, one of our insurance experts will assist in choosing the right plan for you.",
                ]
            },
            {
                title: "Agent Guided Journey",
                icon: UserIcon,
                paragraphs: [
                    "Our licensed insurance experts will ask you some basic questions to help you select the best plans available to you. Our team will do everything they can to make this call as short and straightforward as possible.",
                ]
            },
            {
                title: "Approval and Acceptance",
                icon: DocumentIcon,
                paragraphs: [
                    "We will work directly with the carrier to get you an offer. Keep an eye on your inbox as we will keep you in the loop from start to finish.",
                ]
            }
        ]
    }
}